import React from 'react'

import { Brief } from '@disco/types/types/brief'
import { formatDateWithTimezone } from '@disco/utils/time-utils'

import { Box, Text } from 'components/ds'

interface BriefCardProps {
  brief: Brief
}

export const BriefCard: React.FC<BriefCardProps> = ({ brief }) => {
  const { name, modified } = brief

  return (
    <Box>
      <Box>
        <Box>
          <Text size="2" weight="medium" title={name}>
            {name || 'Brief title'}
          </Text>
        </Box>

        {modified && (
          <Box>
            <Text size="2" color="gray">
              Last Updated: {formatDateWithTimezone(modified)}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}
